import React, { useMemo, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Input,
  InputAdornment,
  OutlinedInput,
  createSvgIcon,
  FormHelperText,
  Checkbox,
  ListItemText,
  Box,
  Button,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputField from "../inputfiled/Inputfiled";
import Uparrow from "../../Icon/Uparrow";
import { ThemeColor } from "../theme/color";
import { FontFamily } from "../theme/fontFamily";

const icon = createSvgIcon(
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 4.5L6 7.5L3 4.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CustomSelect = ({
  label,
  value,
  error,
  onChange,
  multiple,
  onBlur,
  disabled,
  option,
  helperText,
  onSelect,
  defaultValue,
  // Long lists (universities, programs...) get a search box inside the dropdown.
  // Pass searchable={false} to force it off, or true to always show it.
  searchable,
  searchPlaceholder = "Search...",
  // roleType=roleType || false,
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const handleSelectAllChange = (event) => {
    const isAllSelected = event.target.value.includes("select_all");
    const activeOptions = option.map((opt) => opt._id);

    if (isAllSelected) {
      // Toggle Select All
      const newValue =
        value.length === activeOptions.length ? [] : activeOptions;
      onChange({
        target: {
          value: newValue,
        },
      });
    } else {
      onChange(event);
    }
  };

  const ITEM_SELECTED_STYLE = {
    backgroundColor: "#e3f2fd", // light blue background when selected
    color: "#1976d2", // MUI blue text
  };

  const ITEM_DEFAULT_STYLE = {
    backgroundColor: "white",
    color: "black",
  };

  // const isAllChecked = value.length === option.length;
  // const isIndeterminate = value.length > 0 && value.length < option.length;
  // ensure option is always an array to avoid runtime errors in renderValue
  const opts = option || [];

  const showSearch = searchable !== undefined ? searchable : opts.length > 8;

  const filteredOpts = useMemo(() => {
    if (!showSearch || !searchTerm.trim()) return opts;
    const needle = searchTerm.trim().toLowerCase();
    return opts.filter((opt) =>
      String(opt?.title ?? "")
        .toLowerCase()
        .includes(needle)
    );
  }, [opts, searchTerm, showSearch]);

  return (
    <FormControl
      fullWidth
      className="mb-2"
      size="small"
      // sx={{
      //   "& .MuiOutlinedInput-root": {
      //     height: "50px",
      //     // Adjust the height as needed
      //     "& .MuiSelect-select": {
      //       padding: "8px",
      //       borderColor: "red", // Adjust padding to control height further
      //     },
      //     "& .MuiOutlinedInput-notchedOutline": {
      //       border: `0.2 solid rgb(217,217,217)`, // Default border color
      //     },
      //     "& label": {
      //       color: "black",
      //       fontWeight: "550 !important",
      //       fontSize: "0.9rem !important",
      //       // lineHeight: "1.4375em",
      //       letterSpacing: "0.00938em",
      //     },
      //     "&:hover .MuiOutlinedInput-notchedOutline": {
      //       borderColor: ThemeColor.GREY, // Border color on hover
      //     },
      //     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      //       borderColor: ThemeColor.LIGHTPURPLE, // Border color when focused
      //     },
      //   },
      // }}
      sx={{
        // Label styling (must be outside the input root)
        "& .MuiInputLabel-root": {
          color: "black",
          fontWeight: 520,
          fontSize: "0.9rem",
          letterSpacing: "0.00938em",
          marginTop:"7px",
          fontFamily:"Lato !important"
        },
        "& .MuiInputLabel-root.Mui-disabled": {
          color: "black !important",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "black", // Optional: keep label black even when focused
        },

        // Outlined input container
        "& .MuiOutlinedInput-root": {
          height: "50px",

          // The select dropdown's text
          "& .MuiSelect-select": {
            padding: "8px",
          },

          // Border of the select
          "& .MuiOutlinedInput-notchedOutline": {
            border: `0.2px solid rgb(217,217,217)`,
          },

          // On hover
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: ThemeColor.GREY,
          },

          // On focus
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: ThemeColor.LIGHTPURPLE,
          },

          "&.Mui-disabled": {
            cursor: "not-allowed !important",
            "& .MuiSelect-select": {
              cursor: "not-allowed !important",
              color: "black !important",
              WebkitTextFillColor: "black !important",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(217, 217, 217, 1) !important",
            },
            "& .MuiSelect-icon": {
              color: "black !important",
              cursor: "not-allowed !important",
            },
          },
        },
      }}
    >
      <InputLabel
        id="custom-select-label"
        sx={{
          color: "black", // Default color
          "&.Mui-focused": {
            color: ThemeColor.LIGHTPURPLE, // Color when focused
          },
          "&.MuiFormLabel-filled": {
            color: ThemeColor.GREY, // Color when the select has a value
          },
          "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -8px) scale(0.75)", // Custom transform when label is shrunk
            backgroundColor: "#fff", // Optional: background color behind the label when shrunk
            padding: "0 4px", // Optional: padding around the label when shrunk
          },
        }}
      >
        {label}
      </InputLabel>
      {/* <Select
        value={value}
        multiple={multiple}
        onChange={handleSelectAllChange}
        // fullWidth={fullWidth}
        displayEmpty
        renderValue={(selected) => {
          return multiple
            ? selected
                .map((_id) => option.find((opt) => opt._id === _id)?.title)
                .join(", ")
            : option.find((opt) => opt._id === selected)?.title;
        }}
      >
        {multiple && (
          <MenuItem value="select_all">
            <Checkbox checked={isAllChecked} indeterminate={isIndeterminate} />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}
        {option.map((opt) => (
          <MenuItem key={opt._id} value={opt._id}>
            <Checkbox checked={value.includes(opt._id)} />
            {opt.title}
          </MenuItem>
        ))}
      </Select> */}

      <Select
        labelId="custom-select-label"
        id="custom-select"
        className="w-100"
        value={value}
        defaultValue={defaultValue}
        variant="outlined"
        onChange={onChange}
        onBlur={onBlur}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setSearchTerm("");
        }}
        multiple={multiple}
        IconComponent={icon}
        placeholder="ooo"
        disabled={disabled}
        error={error}
        onSelect={onSelect}
        MenuProps={{
          autoFocus: false,
          PaperProps: {
            sx: {
              maxHeight: 380,
              borderRadius: "12px",
              boxShadow: "0 12px 32px rgba(0, 0, 0, 0.15)",
              border: "1px solid #E2E8F0",
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-thumb": {
                bgcolor: "#CBD5E1",
                borderRadius: 10,
              },
            },
          },
        }}
        renderValue={(selected) => {
          try {
            if (multiple) {
              if (!Array.isArray(selected)) return "";
              return selected
                .map((_id) => opts.find((o) => String(o._id) === String(_id))?.title || "")
                .filter(Boolean)
                .join(", ");
            }
            return opts.find((o) => String(o._id) === String(selected))?.title || "";
          } catch (e) {
            return "";
          }
        }}
      >
        {/* {multiple && (
          <MenuItem value="select_all">
            <Checkbox
              checked={
                value.length ===
                option.filter((opt) => opt.isActive !== "N").length
              }
              indeterminate={
                value.length > 0 &&
                value.length <
                  option.filter((opt) => opt.isActive !== "N").length
              }
            />
            Select All
          </MenuItem>
        )} */}
        {showSearch && (
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              px: 1,
              pt: 1,
              pb: 0.5,
              backgroundColor: "#fff",
            }}
            // keep clicks / keystrokes inside the field instead of letting the
            // Select treat them as option navigation or a selection
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <TextField
              autoFocus
              fullWidth
              size="small"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" sx={{ color: "#98a2b3" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  backgroundColor: "#f6faff",
                },
              }}
            />
          </Box>
        )}

        {filteredOpts.length === 0 && showSearch ? (
          <MenuItem disabled>No match found</MenuItem>
        ) : (
          filteredOpts.map((option) => {
            const isSelected = multiple
              ? Array.isArray(value) && value.some((v) => String(v) === String(option._id))
              : String(value) === String(option._id);
            return (
              <MenuItem
                // `disabled` lets a caller grey out an option for its own
                // reasons - e.g. a program already used by another commission.
                disabled={option.isActive === "N" || option.disabled === true}
                key={option._id}
                value={option._id}
                sx={{
                  py: 1,
                  px: 1.5,
                  fontSize: "0.85rem",
                  display: "flex",
                  alignItems: "center",
                  "&:hover": {
                    bgcolor: "#EFF6FF",
                  },
                  "&.Mui-selected": {
                    bgcolor: "#DBEAFE !important",
                    color: "#1E40AF",
                    fontWeight: 500,
                  },
                }}
              >
                {multiple && (
                  <Checkbox
                    size="small"
                    checked={isSelected}
                    sx={{
                      p: 0,
                      mr: 1.2,
                      color: "#94A3B8",
                      "&.Mui-checked": {
                        color: ThemeColor.PURPLE,
                      },
                    }}
                  />
                )}
                {option.title}
              </MenuItem>
            );
          })
        )}

        {/* Sticky bottom bar with OK button to close dropdown */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            px: 1.8,
            py: 1,
            backgroundColor: "#fff",
            borderTop: "1px solid #E2E8F0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.06)",
          }}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {multiple && Array.isArray(value) && value.length > 0 ? (
            <Typography fontSize="0.75rem" color="#64748B" fontWeight={500}>
              {value.length} selected
            </Typography>
          ) : (
            <Box />
          )}

          <Button
            size="small"
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
              setSearchTerm("");
            }}
            sx={{
              bgcolor: ThemeColor.PURPLE,
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8rem",
              px: 2.2,
              py: 0.4,
              borderRadius: "6px",
              boxShadow: "0 2px 8px rgba(21, 83, 158, 0.3)",
              transition: "all 0.15s ease",
              "&:hover": {
                bgcolor: "#0F3E78",
                boxShadow: "0 4px 12px rgba(21, 83, 158, 0.4)",
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Select>
      {/* component="div": helperText is often a <Typography> (a <p>), and
          FormHelperText is a <p> by default — <p> inside <p> is invalid. */}
      <FormHelperText component="div">{helperText}</FormHelperText>
    </FormControl>
  );
};

export default CustomSelect;
